export function farloCrmToggle() {
    const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
    const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

    buttons.forEach(function(button) {
        let closestCrmBlock = null;
        let closestDistance = Infinity;

        crmBlocks.forEach(function(block) {
            const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
            if (distance > 0 && distance < closestDistance) {
                closestDistance = distance;
                closestCrmBlock = block;
            }
        });

        if (closestCrmBlock) {
            const crmId = closestCrmBlock.getAttribute('data-crm-id');
            button.setAttribute('data-crm-button-for', crmId);
        }
    });

    buttons.forEach((_sel) => {
        _sel.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            farloUiCrmSignup(e);
        });
    });
}